import { API } from 'aws-amplify';

//const API_NAME = 'admin-api';
const API_NAME_V2 = 'admin-api-v2';

export const getAllUsers = async () => {
  return API.get(API_NAME_V2, '/users', {});
};

export const createUser = async (data) => {
  return API.post(API_NAME_V2, '/user', { body: data });
};

export const disableUser = async (username) => {
  return API.del(API_NAME_V2, `/user/${username}`, {});
};

export const updateUser = async (username, data) => {
  return API.put(API_NAME_V2, `/user/${username}`, { body: data });
};
